import React, { useEffect, useState } from 'react'
import { Pagination, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from 'use-debounce'
import { reConstructionCategoryActions } from './store/actions'
import Notifications from '../../../helpers/Notifications'
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import LocalLoading from '../../../components/Loading/Local'
import UpdateIcon from '../../../components/Icons/update.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import AddReConstructionCategoryModal from './add'
import UpdateReConstructionCategoryModal from './update'
import ModalAudit from '../ModalAudit'
import AddIcon from '../../../components/Icons/add.svg'
import { useTranslation } from "react-i18next"
import api from "./store/api"
import dayjs from "dayjs"
import "./style.css"

const ReConstructionCategory = (props) => {
    //const {isModify = false} = props
    const isModify = false;
    const [updateVisible, setUpdateVisible] = useState(false)
    const [addVisible, setAddVisible] = useState(false)
    const [visibleAudit, setVisibleAudit] = useState(false)
    const [idRecordAudit, setIdRecordAudit] = useState(null)
    const [currentCategory, setCurrentCategory] = useState(null)
    const [filter, setFilter] = useState(null)
    const [table, setTable] = useState(null)
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1)
    const { paged, isSending, changed } = useSelector(state => state.reConstructionCategoryReducer)
    const [search, setSearch] = useState(null)
    const [searchValue] = useDebounce(search, 500)
    const { t } = useTranslation(['common', 'valid', 'nri'])
    const dispatch = useDispatch()
    const pageSize = 10

    const onPaginationChange = (value) => {
        setPage(value)
        const params = {
            name: searchValue,
            page: value,
            pageSize: pageSize
        }
        getPagedAll(params)
    }

    useEffect(() => {
        return () => {
            dispatch(reConstructionCategoryActions.clear())
        }
    }, [])

    useEffect(() => {
        onPaginationChange(1)
    }, [searchValue])

    useEffect(() => {
        if (changed) {
            Notifications.successNotice(changed, "", 10)
            onPaginationChange(page)
        }
    }, [changed])

    useEffect(() => {
        if (paged?.items) {
            setCount(paged.count)
            setTable(paged.items)
        }
    }, [paged])

    const getPagedAll = (values) => {
        dispatch(reConstructionCategoryActions.getPagedAll(values))
    }

    const create = (values) => {
        dispatch(reConstructionCategoryActions.createCategory(values))
    }

    const update = (values) => {
        dispatch(reConstructionCategoryActions.updateCategory(values))
    }

    const deleteCategory = (values) => {
        dispatch(reConstructionCategoryActions.deleteCategory(values))
    }

    const restoreCategory = (values) => {
        dispatch(reConstructionCategoryActions.restoreCategory(values))
    }

    const comColumns = [
        {
            title: t('nri:categoryName'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t('nri:codeKKM'),
            dataIndex: 'codeKKM',
            key: 'codeKKM'
        },
        {
            title: t('nri:parentCategory'),
            dataIndex: 'parent',
            key: 'parent',
            render: (obj) => {
                return (obj?.name)
            }
        },
    ]

    const manageColumns = [
        ...comColumns,
        {
            title: t('common:dateCreate'),
            dataIndex: 'createDate',
            key: 'createDate',
            render: (obj) => {
                return (dayjs.utc(obj)?.format('DD.MM.YYYY'))
            }
        },
        {
            dataIndex: 'id',
            key: 'id',
            render: (id, obj) => (
                <div className="changeIcon">
                    <img alt=""
                        src={UpdateIcon}
                        onClick={() => {
                            setUpdateVisible(true)
                            setCurrentCategory(obj)
                        }}
                    />
                    <img alt=""
                        className="audit-icon-svg"
                        src={AuditIcon}
                        title={t('common:historyOfChange')}
                        onClick={() => {
                            setVisibleAudit(true)
                            setIdRecordAudit(obj.id)
                        }}
                    />
                </div>
            )
        }
    ]

    return (
        <>
            <div className="header-admin-nsi">
                <CustomInput
                    maxLength={64}
                    placeholder="Введите название/код"
                    onChange={(e) => setSearch(e.target.value)}
                />
                {isModify
                    ? (
                        <CustomButton
                            className="add-nsi"
                            type="green"
                            onClick={() => {
                                setAddVisible(true)
                            }}
                        >
                            <div>
                                <img alt="" src={AddIcon} />
                                <span>{t('action:add')}</span>
                            </div>
                        </CustomButton>
                    )
                    : null
                }
            </div>
            <Table
                columns={isModify ? manageColumns : comColumns}
                dataSource={table?.map((el, idx) => ({ key: el.code, ...el }))}
                loading={{ spinning: isSending, indicator: <LocalLoading /> }}
                pagination={false}
                rowClassName={(row) => (row.isDeleted ? "row-deleted" : "")}
                scroll={{ x: 1200 }}
            />
            {count > pageSize
                ? (
                    <Pagination
                        showQuickJumper
                        current={page}
                        pageSize={pageSize}
                        showSizeChanger={false}
                        size="small"
                        total={count}
                        onChange={onPaginationChange}
                    />)
                : null
            }
            <AddReConstructionCategoryModal
                create={create}
                setVisible={setAddVisible}
                visible={addVisible}
            />
            <UpdateReConstructionCategoryModal
                currentCategory={currentCategory}
                setCurrentCategory={setCurrentCategory}
                setVisible={setUpdateVisible}
                update={update}
                visible={updateVisible}
            />
            <ModalAudit
                columns={comColumns}
                setIdRecordAudit={setIdRecordAudit}
                idRecordAudit={idRecordAudit}
                setVisible={setVisibleAudit}
                visible={visibleAudit}
                pageSize={pageSize}
                func={api.getPagedAudit}
            />
        </>
    )
}

export default ReConstructionCategory